import Form from "@ant-design/compatible/es/form";
import FormCard from "@impero-com/common/components/formCard";
import FormCardContainer from "@impero-com/common/components/formCardContainer";
import RightSideIcon from "@impero-com/common/components/rightSideIcon";
import { t } from "@impero-com/common/utils/i18n";
import { Button, CardFooter, FormSubtitle, FormTitle } from "@impero-com/ui";
import { Link } from "react-router-dom";

import expiredLink from "img/expired-link.svg";

const FormItem = Form.Item;

const LinkExpired = () => {
    return (
        <FormCardContainer
            rightSide={
                <RightSideIcon icon={expiredLink} customImages={false} />
            }
        >
            <FormTitle title={t("LoginFlow_LinkHasExpired")} />
            <FormSubtitle subtitle={t("LoginFlow_LinkHasBeenUsed")} />
            <FormCard>
                <FormItem>
                    <Link to="/forgot">
                        <Button
                            id="loginFormSubmitBtn"
                            variant="primary"
                            type="submit"
                            block
                        >
                            {t("LoginFlow_GetNewEmail")}
                        </Button>
                    </Link>
                </FormItem>
            </FormCard>

            <CardFooter />
        </FormCardContainer>
    );
};

export default LinkExpired;
